import { cn } from '@dfh-corp-sites/ui/utils'
import React, { useMemo, useRef } from 'react'

import { MainMenuFragmentFragment } from '../../../graphql/gatsby'
import { useSanityRoleAndContextBasedContent } from '../../../lib/sanity'
import { LinkRef } from '../Link'
import MenuEntryLink from './MenuEntryLink'

type MainMenuEntries = NonNullable<MainMenuFragmentFragment['mainMenu']>

export interface MainMenuEntryProps {
  menuEntry: NonNullable<MainMenuEntries[number]>
  isActive: boolean
}

export const MainMenuEntry: React.FC<MainMenuEntryProps> = React.memo(({ menuEntry, isActive }) => {
  const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()
  const shouldDisplay = useMemo(
    () => shouldDisplayContent(menuEntry),
    [menuEntry, shouldDisplayContent],
  )

  const linkRef = useRef<LinkRef>(null)

  if (!shouldDisplay) {
    return null
  }

  return (
    <MenuEntryLink
      dispensaryContactInformationRequired={menuEntry.dispensaryContactInformationRequired}
      link={menuEntry.link}
      ref={linkRef}
      className={cn(
        'border-b-[3px] border-transparent',
        'hover:border-brand-navy hover:font-bold hover:cursor-pointer',
        { 'border-brand-navy font-bold': isActive },
      )}
    >
      {menuEntry.name}
    </MenuEntryLink>
  )
})

MainMenuEntry.displayName = 'MainMenuEntry'
